/* eslint-disable indent */
// disable eslint for indent because it fails for `const`s outside the `class`

// http://stackoverflow.com/questions/32647215/declaring-static-constants-in-es6-classes
const MAP_STYLES = [
        {
          featureType: 'all',
          elementType: 'labels.text.fill',
          stylers: [
            {
              saturation: 36
            },
            {
              color: '#333333'
            },
            {
              lightness: 40
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#ffffff'
            },
            {
              lightness: 16
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#fefefe'
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#47625e'
            },
            {
              lightness: '0'
            },
            {
              weight: '1.0'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'labels.text',
          stylers: [
            {
              color: '#818181'
            },
            {
              weight: '0.01'
            }
          ]
        },
        {
          featureType: 'administrative.country',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#233237'
            },
            {
              weight: '1'
            },
            {
              lightness: '50'
            }
          ]
        },
        {
          featureType: 'administrative.province',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#233237'
            },
            {
              lightness: '80'
            }
          ]
        },
        {
          featureType: 'landscape.natural',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#233237'
            },
            {
              lightness: '90'
            }
          ]
        },
        {
          featureType: 'landscape.natural.landcover',
          elementType: 'geometry.fill',
          stylers: [
            {
              lightness: '0'
            }
          ]
        },
        {
          featureType: 'landscape.natural.terrain',
          elementType: 'geometry.fill',
          stylers: [
            {
              lightness: '-8'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            },
            {
              lightness: 21
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#a7d0bf'
            },
            {
              lightness: '50'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 17
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 29
            },
            {
              weight: 0.2
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 18
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 16
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f2f2f2'
            },
            {
              lightness: 19
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#8db2d0'
            },
            {
              lightness: '50'
            }
          ]
        }
      ],

      MAX_ZOOM = 18,
      MIN_ZOOM = 5,

      DEFAULT_ZOOM = 6,

      CITY_ZOOM = 12,

      GERMANY_CENTER = [51.5167, 9.9167],

      DEFAULT_OPTIONS = {
        scrollwheel: false,
        styles: MAP_STYLES
      };

/* eslint-enable indent */

class QBMap {
  // that way, don't need parenthesis when calling
  static get MAP_STYLES() {
    return MAP_STYLES;
  }

  static get MAX_ZOOM() {
    return MAX_ZOOM;
  }

  static get MIN_ZOOM() {
    return MIN_ZOOM;
  }

  static get DEFAULT_ZOOM() {
    return DEFAULT_ZOOM;
  }

  static get CITY_ZOOM() {
    return CITY_ZOOM;
  }

  static get GERMANY_CENTER() {
    return GERMANY_CENTER;
  }

  static get DEFAULT_OPTIONS() {
    return DEFAULT_OPTIONS;
  }
}

export default QBMap;



// WEBPACK FOOTER //
// ./components/maps/qbMap.js